import { CARD_ELEMENT_ASSETS } from "@/constants/cardAssets"
import { CardElement } from "@/types/battle"

export default function ElementIconImage({
  element,
  size = 16,
}: {
  element: CardElement
  size?: number
}) {
  const src = CARD_ELEMENT_ASSETS[element].elementIcon ?? undefined
  if (!src) return null
  return (
    <img
      src={src}
      alt=""
      width={size}
      height={size}
      className="object-contain"
      draggable={false}
    />
  )
}
